import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { DarkCommsRainSubColor } from "@cart-ui/components/incognito-mode-widget/constants";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const HalfCardWrapper = styled.div(({ theme }) => ({
    padding: theme.spacing.medium,
    marginTop: theme.spacing.xSmall,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
}));

export const PrivateOrderTextWrapper = styled.div(() => ({
    marginTop: "-72px",
}));

export const PrivateOrderText = styled(Text)(() => ({
    color: DarkCommsRainSubColor,
}));

export const PrivateOrderImageWrapper = styled.div(({ theme }) => ({
    marginTop: `calc(${theme.spacing.xLarge} * -1)`,
}));

export const PrivateOrderBenefitsWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
    marginTop: theme.spacing.small,
}));

export const BenefitTextIconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xSmall,
}));

export const BenefitIconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.spacing.xSmall,
}));

export const PrivateOrderButton = styled.button(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
    marginTop: theme.spacing.xLarge,
    backgroundColor: DarkCommsRainSubColor,
    width: "100%",
    borderRadius: theme.spacing.small,
}));

export const BenefitIcon = styled(Image)<{ isNotificationIcon: boolean }>(({ theme, isNotificationIcon }) => ({
    width: theme.spacing.medium,
    height: isNotificationIcon ? theme.spacing.xLarge : theme.spacing.medium,
}));
